module.exports = __webpack_public_path__ + "media/images/top/img_pickup_kurage-0e8254f96a2df84eeea555a0f8f3056d.webp";